import React from 'react'
import { Helmet } from 'react-helmet-async'
import SEO from '../../components/SEO'
import Footer from '../../components/Footer'
import Navbar from '../../components/Navbar'
import Contact from './components/Contact'
import { structuredData } from '../../data/structuredData'

export default function Contacts() {
  return (
    <>
      <SEO
        title='Contact Us'
        description='Get in touch with RaStegHub — reach out to discuss your project, ask a question, or say hello.'
        url='/contacts'
      />
      <Helmet>
        <script type='application/ld+json'>{JSON.stringify(structuredData)}</script>
      </Helmet>
      <div className="contacts">
        <Navbar />
        <Contact />
        <Footer />
      </div>
    </>
  )
}